import validate from 'validate-norwegian-ssn';

const isValidNorwegianNationalNumber = (value) => {
  const isValidSSN = value.length !== 0 && value.length === 11 && validate(value);

  return value.length !== 0 ? isValidSSN : isValidSSN || value.length === 0;
};

export default isValidNorwegianNationalNumber;
